/** "01:30:00" → "1 hr 30 min"; anything else is shown as typed. */
export function formatDuration(value: string | null | undefined): string {
  if (!value) return '';
  const match = /^(\d{1,2}):(\d{2})(?::\d{2})?$/.exec(value.trim());
  if (!match) return value;
  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  const parts = [hours ? `${hours} hr` : '', minutes ? `${minutes} min` : ''].filter(Boolean);
  return parts.length ? parts.join(' ') : value;
}
